import React from 'react';
import classNames from 'classnames';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import LearnerUnselectableResponse from './LearnerUnselectableResponse';

export default function LearnerInteraction({
  interaction,
  position,
  currentInteraction,
  showTyping,
  totalInteractions,
  activeResponse,
  conversationComplete,
}) {
  const correctResponse = interaction.responses.find(
    response => response.correct,
  );

  return (
    <div key={interaction.id}>
      {position <= currentInteraction &&
        !(position === currentInteraction && showTyping) && (
          <div className="OnDemandPracticeConversation-chatBubble OnDemandPracticeConversation-chatBubbleLeft">
            <Text
              variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}
              className="OnDemandPracticeConversation-bubbleCount"
            >
              {position + 1}/{totalInteractions}
            </Text>
            <p
              className={classNames('mb-0', {
                'fs-i':
                  interaction.subject ===
                  t(
                    'practice.on_demand_practice.editor.conversations.incoming_chat_filler',
                  ),
              })}
            >
              {interaction.subject}
            </p>
          </div>
        )}
      {/* show only the correct interaction responses in the history */}
      {position < currentInteraction && (
        <LearnerUnselectableResponse
          response={correctResponse}
          activeResponse={activeResponse}
        />
      )}
      {/* show the incorrect response with the explanation or the last correct response when finished */}
      {position === currentInteraction &&
        !!activeResponse &&
        (!activeResponse.correct || conversationComplete) && (
          <LearnerUnselectableResponse
            response={activeResponse}
            activeResponse={activeResponse}
          />
        )}
    </div>
  );
}
